import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { PractitionersSearchResult } from '~/api';
import { SearchResultGroupByLocation } from '~/utilities';

export interface ActiveSelectionState {
  clinic?: SearchResultGroupByLocation;
  practitioner?: PractitionersSearchResult;
}

export const initialState: ActiveSelectionState = {
  clinic: undefined,
  practitioner: undefined,
};

export const activeSelectionSlice = createSlice({
  name: 'activeSelection',
  initialState,
  reducers: {
    clearSelectedClinic: (state) => {
      state.clinic = undefined;
    },
    clearSelectedPractitioner: (state) => {
      state.practitioner = undefined;
    },
    clearAllSelected: (state) => {
      state.clinic = undefined;
      state.practitioner = undefined;
    },
    setSelectedClinic: (
      state,
      action: PayloadAction<SearchResultGroupByLocation>
    ) => {
      state.clinic = action.payload;
    },
    setSelectedPractitioner: (
      state,
      action: PayloadAction<PractitionersSearchResult>
    ) => {
      state.practitioner = action.payload;
    },
  },
});

type SliceState = { activeSelection: ActiveSelectionState };

export const selectSelectedClinic = (state: SliceState) =>
  state.activeSelection.clinic;
export const selectSelectedPractitioner = (state: SliceState) =>
  state.activeSelection.practitioner;

export const {
  setSelectedClinic,
  clearSelectedClinic,
  setSelectedPractitioner,
  clearSelectedPractitioner,
  clearAllSelected,
} = activeSelectionSlice.actions;

export default activeSelectionSlice.reducer;
